import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DemandeAnalyseDevisComponent } from './components/demande-analyse-devis/demande-analyse-devis.component';
import { DemandeHospitalisationComponent } from './components/demande-hospitalisation/demande-hospitalisation.component';
import { DemanderRemboursementsComponent } from './components/demander-remboursements/demander-remboursements.component';
import { FaqComponent } from './components/faq/faq.component';
import { MainHomeComponent } from './components/main-home/main-home.component';
import { MesCourriersComponent } from './components/mes-courriers/mes-courriers.component';
import { MesRemboursementsComponent } from './components/mes-remboursements/mes-remboursements.component';
import { MonProfilComponent } from './components/mon-profil/mon-profil.component';
import { SignedInGuard } from './helpers/guards/signed-in.guard';
import { SignedOutGuard } from './helpers/guards/signed-out.guard';
import { AppLayoutComponent } from './layout/app.layout.component';
import { SuiviDemandesComponent } from './components/suivi-demandes/suivi-demandes.component';
import { CoordonneesBancairesComponent } from './components/coordonnees-bancaires/coordonnees-bancaires.component';
import { GererMesBenefsComponent } from './components/gerer-mes-benefs/gerer-mes-benefs.component';
import { MesDocumentsContractuelsComponent } from './components/mes-documents-contractuels/mes-documents-contractuels.component';
import { NousContacterComponent } from './components/nous-contacter/nous-contacter.component';
import { AcceptedCguGuard } from "./helpers/guards/acceptedCguGuard";
import { MonAdhesionComponent } from './components/mon-adhesion/mon-adhesion.component';
import { DemandeResilisationComponent } from './components/demande-resilisation/demande-resilisation.component';
import { MesservicesComponent } from './layout/messervices/messervices.component';
import { GestionContratDCComponent } from './components/gestion-contrat-dc/gestion-contrat-dc.component';
import { RemboursementCapitalDecesComponent } from './components/remboursement-capital-deces/remboursement-capital-deces.component'
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { CotisationsComponent } from "./components/cotisations/cotisations.component";
import { MesCartesTiersPayantComponent } from './components/mes-cartes-tiers-payant/mes-cartes-tiers-payant.component';
import { MesProduitsComplementairesComponent } from './components/mes-produits-complementaires/mes-produits-complementaires.component';


export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');

}


import { ConsentGuard } from './helpers/guards/consent.guard';
import { CookieErrorComponent } from './components/cookie-consent-error-page/cookie-error.component';
import {DemandeAttestationComponent} from "./components/demande-attestation/demande-attestation.component";
import {MedecinDirectComponent} from "./components/medecin-direct/medecin-direct.component";
import {ReseauDeSoinsComponent} from "./components/reseau-de-soins/reseau-de-soins.component";
import {GeolocalisationPsComponent} from "./components/geolocalisation-ps/geolocalisation-ps.component";
import { MaiiaComponent } from './components/maiia/maiia.component';
import {
  SimulerUnRemboursementComponent
} from "./components/simuler-un-remboursement/simuler-un-remboursement.component";

const routes: Routes = [

  { path: '', component: AppLayoutComponent, canActivateChild: [ConsentGuard,SignedInGuard],
    children: [
      {
        path: '', redirectTo: 'accueil', pathMatch: 'full'
      },
      {
        path: 'accueil', component: MainHomeComponent,canActivate: [AcceptedCguGuard]
      },
      {
        path: 'mes-remboursements', component: MesRemboursementsComponent
      },
      {
        path: 'demander-un-remboursement', component: DemanderRemboursementsComponent
      },
      {
        path: 'mon-profil', component: MonProfilComponent
      },
      {
        path: 'demande-analyse-devis', component: DemandeAnalyseDevisComponent
      },
      {
        path: 'demande-hospitalisation', component: DemandeHospitalisationComponent
      },
      {
        path: 'faq', component: FaqComponent
      },
      {
        path: 'mes-courriers', component: MesCourriersComponent
      },
      {
        path: 'mes-cartes-tiers-payant', component: MesCartesTiersPayantComponent
      },
      {
        path: 'suivi-des-demandes', component: SuiviDemandesComponent
      },
      {
        path: 'coordonnees-bancaires', component: CoordonneesBancairesComponent
      },
      {
        path: 'gerer-mes-beneficiaires', component: GererMesBenefsComponent
      },
      {
        path: 'documents-contractuels', component: MesDocumentsContractuelsComponent
      },
      {
        path: 'nous-contacter', component: NousContacterComponent
      },
      {
        path: 'mon-contrat', component: MonAdhesionComponent,
      },
      {
        path: 'service', component: MesservicesComponent
      },
      {
        path: 'medecin-direct', component: MedecinDirectComponent
      },
      {
         path: 'geolocalisation-ps', component: GeolocalisationPsComponent

      },
      {
        path: 'mes-produits-complementaires', component: MesProduitsComplementairesComponent,
      },
      {
        path: 'demande-resiliation', component: DemandeResilisationComponent
      },
      {
        path: 'gerer-beneficiaire-prevoyance', component: GestionContratDCComponent
      },
      {
        path: 'remboursement-capital-deces', component: RemboursementCapitalDecesComponent
      },
      {
        path: 'cotisations', component: CotisationsComponent
      },
      {
        path: 'demande-attestation', component: DemandeAttestationComponent
      },
      {
        path: 'reseau-de-soins', component: ReseauDeSoinsComponent
      },
      {
        path: 'teleconsultation', component: MaiiaComponent
      },
      {
        path: 'simuler-un-reboursement', component: SimulerUnRemboursementComponent
      }
    ]
  },
  { path: 'access-denied', loadChildren: () => import('./components/auth/accessdenied/accessdenied.module').then(m => m.AccessdeniedModule)},
  { path: 'auth', loadChildren: () => import('./components/auth/auth.module').then(m => m.AuthModule),canActivate: [SignedOutGuard]},
  { path: 'affichage-cgu', loadChildren: () => import('./components/affichage-cgu/affichage-cgu.module').then(m => m.AffichageCguModule), canActivate: [SignedInGuard]},
  { path: 'cookie-error', component: CookieErrorComponent },
  { path: '**', redirectTo: 'auth/login', pathMatch: 'full'}

];
@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
